var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "115.623mm",
    height: "95.2394mm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 1161.55 956.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_105553233670304"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F7",
    fillRule: "nonzero",
    d: "M1094.52 120.75c-57.86,-76.04 -148.07,-120.75 -243.66,-120.75 -42.28,0 -84.11,8.79 -122.84,25.72 -56.3,24.29 -106.51,65.25 -147.23,119.74 -40.72,-54.49 -90.93,-95.45 -147.23,-119.61 -38.76,-16.97 -80.63,-25.75 -122.95,-25.75 -95.55,0 -185.68,44.64 -243.59,120.63 -43.86,57.47 -67.04,129.29 -67.04,207.67 0,112.81 67.27,236.56 199.94,367.98 108.1,107.04 235.85,194.7 302.35,237.41 23.44,15 50.68,22.98 78.5,22.98 27.82,0 55.05,-7.98 78.48,-22.97 66.45,-42.71 194.25,-130.38 302.35,-237.41 132.66,-131.36 199.94,-255.17 199.94,-367.98 0,-78.39 -23.18,-150.2 -67.04,-207.67l0.01 0z",
    "data-original": "#3a0a0e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4B4B",
    fillRule: "nonzero",
    d: "M1095.11 328.42c0,94.41 -60.63,202.33 -180.24,320.77 -103.66,102.76 -227.18,187.39 -291.51,228.59 -12.69,8.1 -27.46,12.42 -42.53,12.42 -15.06,0 -29.84,-4.32 -42.53,-12.42 -64.32,-41.31 -187.74,-125.94 -291.51,-228.59 -119.61,-118.44 -180.24,-226.36 -180.24,-320.77 0,-63.79 18.61,-121.58 53.4,-167.46 32.07,-41.95 77.04,-72.28 127.97,-86.24 20.19,-5.45 41.1,-8.23 62.03,-8.23 0.06,0 0.17,0 0.23,0 81.02,0 174.47,40.51 242.04,155.71 5.95,10.17 16.87,16.43 28.65,16.43 11.79,0 22.7,-6.26 28.65,-16.43 85.85,-146.35 213.47,-172.13 304.29,-147.47 50.94,13.95 95.91,44.28 127.99,86.21 34.82,45.88 53.29,103.77 53.29,167.46l-0 0.01z",
    "data-original": "#f9595f"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.faa499cde38499e96ffd65ca3fe3aab8.svg";
export { ForwardRef as ReactComponent };